<template>
   <div class="addBlocks">
        <div v-if="typesLoadStatus == 1 && blocksLoadStatus == 1 && themesLoadStatus == 1">
            <p>Loading...</p>
        </div>

        <div v-if="typesLoadStatus == 3 && blocksLoadStatus == 3 && themesLoadStatus == 3">
            <p>Something went wrong.</p>
        </div>

        <div class="card mb-3" v-if="typesLoadStatus == 2 && blocksLoadStatus == 2 && themesLoadStatus == 2" :key="forceRerender">
            <div class="card-header dropdown">
                Blocks
                    <span class="text-muted float-right cursor-pointer" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" title="Add block" aria-label="Add block">
                        <i aria-hidden="true" class="fa fa-plus"></i>
                    </span>
                    <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                        <a class="dropdown-item" @click.prevent="addBlock(id)" href="#" v-for="(type, id) in types" :key="id" :value="id">{{ type }}</a>
                    </div>
            </div>
            <div class="card-body">
                <block v-for="(block, index) in blocks" :key="index" :index="index" :name="getTypeName(block.type)">
                    <consumer v-if="block.type == 0" :block="block" :index="index" :locale="locale"></consumer>
                    <complaint v-if="block.type == 1" :block="block" :index="index" :locale="locale"></complaint>
                    <two-links v-if="block.type == 2" :block="block" :index="index" :locale="locale"></two-links>
                    <text-block v-if="block.type == 3" :block="block" :index="index" :locale="locale"></text-block>
                    <custom-button v-if="block.type == 4" :block="block" :index="index" :locale="locale"></custom-button>
                </block>

                 <div class="form-buttons">
                    <button class="btn btn-primary"  @click="storeBlocks">Save</button>
                    <a href class="btn btn-default" @click.prevent="cancelBlocks">Cancel</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Block from "./Block.vue"
import Consumer from "./components/blocks/Consumer.vue"
import Complaint from "./components/blocks/Complaint.vue"
import CustomButton from "./components/blocks/CustomButton.vue"
import TextBlock from "./components/blocks/TextBlock.vue"
import TwoLinks from "./components/blocks/TwoLinks.vue"
export default {
    components: {
        Block,
        Consumer,
        Complaint,
        CustomButton,
        TextBlock,
        TwoLinks
    },
    props: {
        site_id: Number,
        locale: String,
    },
    computed: {
        typesLoadStatus() {
            return this.$store.getters.getTypesLoadStatus;
        },
        themesLoadStatus() {
            return this.$store.getters.getThemesLoadStatus;
        },
        blocksLoadStatus() {
            return this.$store.getters.getBlocksLoadStatus;
        },
        types() {
            return this.$store.getters.getTypesData;
        },
        blocks() {
            return this.$store.getters.getBlocksData;
        },
        forceRerender() {
            return this.$store.getters.getForceRerender;
        }
    },
    data() {
        return {}
    },
    beforeCreate() {
        this.$store.dispatch('loadTypesData');
    },
    mounted() {
        this.$store.dispatch('loadThemesData', { 'locale' : this.locale });//consumer block
        this.$store.dispatch('loadBlocksData', {'site_id' : this.site_id});
    },
    methods: {
        addBlock(id) {
            this.$store.dispatch('addBlock', {'id' : id})
        },
        storeBlocks() {
            this.$store.dispatch('storeBlocks', {'site_id' : this.site_id, 'locale' : this.locale})
        },
        cancelBlocks() {
            window.location='/' + this.locale + '/admin/sites';
        },
        getTypeName(id) {

            return this.types[id];
        },
    }
}
</script>

<style lang="scss">
</style>

